import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Achievement, AchievementRoute, Distancias } from '../../../../api/interfaces/register';
import { DomSanitizer } from '@angular/platform-browser';
import { MatIconRegistry } from "@angular/material/icon";
import { RegisterService } from '../../../../api/services/register/register.service';
import { MobileDetectorService } from '../../../../services/mobileDetector/mobile-detector.service';
import { ParseTimeService } from 'src/app/utils/parseTime/parse-time.service';
import { ActivatedRoute } from '@angular/router';
import { SharedDataService } from 'src/app/services/sharedData/shared-data.service';
import { Masks } from 'src/app/enums/mask';
@Component({
  selector: 'app-inputs-achievements',
  templateUrl: './inputs-achievements.component.html',
  styleUrls: ['./inputs-achievements.component.scss']
})
export class InputsAchievementsComponent implements OnInit {

  selected: Date;
  maxDate: Date = new Date();

  routeOptions: Distancias[] = [];
  achievements: Achievement[] = [];

  activo: boolean = true;
  isRuta: boolean = false;
  isMobile: boolean = false;
  distanceMeters: boolean = false;
  distanceKMeters: boolean = false;
  isMetasObjetivos: boolean = false;

  achievementsRoute: AchievementRoute[] = [];

  achievementForm = new FormGroup({
    distance: new FormControl(),
    time: new FormControl([Validators.required], Validators.minLength(6)),
    date: new FormControl(),
    type: new FormControl(),
    distanciaTipoId: new FormControl(),
    id: new FormControl(),
  });


  @Input('i') i?: number;
  @Input('mode') mode?: string;
  @Input('disable') disable?: boolean;
  @Input ('achievement') achievement : any;

  @Output() removeAchievementEvent = new EventEmitter<any>();
  @Output() saveAchievementEvent: EventEmitter<any> = new EventEmitter();
  timeMask: string = "";

  constructor(
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
    private registerService: RegisterService,
    private mobileDetectorService: MobileDetectorService,
    private parseTimeService: ParseTimeService,
    private router: ActivatedRoute,
    private sharedData: SharedDataService,
  ) {
    this.matIconRegistry.addSvgIcon(
      `delete`,
      this.domSanitizer.bypassSecurityTrustResourceUrl('../../../../../assets/delete.svg')
    );
   }

   ngOnInit(): void {
    this.timeMask = Masks.TIME;
    this.isMobile = this.mobileDetectorService.isMobile();
    const url = this.router.snapshot.routeConfig.path;

    if(url == "alumno/metas-objetivos") {
      this.isMetasObjetivos = true;
    }

    this.sharedData.currentMessage.subscribe(message => {
      if(message =="editAchievements") {
        this.achievementForm.controls['distance'].enable();
        this.achievementForm.controls['time'].enable();
        this.achievementForm.controls['date'].enable();
        this.achievementForm.controls['type'].enable();
      }
      if(message == "remove" && this.achievement.activo != undefined) {
        this.activo = this.achievement.activo;
      }
    });

     if(this.mode === "ruta") {
        this.isRuta = true;
        this.getOptions();
     } else {
       this.patchAchievement();
     }

     if(this.mode === "ultra" || this.mode == "trail") {
       this.distanceKMeters = true;
     }
     if(this.mode === "pista") {
       this.distanceMeters = true;
     }

    this.addAchievement();

    if(this.disable) {
      this.achievementForm.controls['distance'].disable();
      this.achievementForm.controls['time'].disable();
      this.achievementForm.controls['date'].disable();
      this.achievementForm.controls['type'].disable();
    }
  }


  removeAchievement() {
    if(this.achievement) {
      this.achievement.valid = true;
      if(!this.achievement.id) {
        this.achievement.activo = false;
      }
    }
    if(!this.disable) {
      this.removeAchievementEvent.emit(this.i);
      // this.activo = false;
    }
  }

  addAchievement() {
    this.achievementForm.value.i = this.i;
    // const { time } = this.achievementForm.getRawValue();
    // if(time) {
    //   if(time && time.toString().length == 5) {
    //     this.achievementForm.patchValue({time: this.achievementForm.value.time+':00'});
    //   }
    // }
    if(this.achievementForm.value.date) {
      let auxDate = this.achievementForm.value.date;
      if(auxDate._d) {
        auxDate._d.setHours(12);
      }
    }
    this.saveAchievementEvent.emit(this.achievementForm.value);
  }

  getOptions() {
    this.registerService.getRouteOptions()
    .subscribe(response => {
      this.routeOptions = response;
      // let remover: number = this.routeOptions.findIndex(option => option.distanciaDescripcion == "Kilómetros");
      // this.routeOptions.splice(remover, 1);
      // remover = this.routeOptions.findIndex(option => option.distanciaDescripcion == "Metros");
      // this.routeOptions.splice(remover, 1);
      this.routeOptions.forEach(option => {
        option.selected = false;
      })
      this.patchRoute();
    },
      error => {
        console.error(error);
      });
  }

  patchRoute() {
    if(this.achievement) {
      let time: string = this.parseTimeService.parseToString(this.achievement.tiempoMarcaHoras, this.achievement.tiempoMarcaSegundos, this.achievement.tiempoMarcaMinutos);
      this.achievementForm.patchValue({date: this.achievement.fechaMarca});
      this.achievementForm.patchValue({time: time});
      this.achievementForm.patchValue({id: this.achievement.id});
      this.achievementForm.patchValue({distanciaTipoId: this.achievement.distanciaTipoId});
      let found: Distancias = this.routeOptions.find( option => {
        if(option.id == this.achievement.distanciaTipoId) {
          return option;
        }
      });
      if(found) {
        found.selected = true;
      }
      this.achievementForm.patchValue({type: found});
      this.activo = this.achievement.activo;
    } else {
      this.achievementForm.patchValue({id: null});  //requerido por backend
    }
  }

  patchAchievement() {
    if(this.achievement) {
      let time: string = this.parseTimeService.parseToString(this.achievement.tiempoMarcaHoras, this.achievement.tiempoMarcaSegundos, this.achievement.tiempoMarcaMinutos);
      this.achievementForm.patchValue({date: this.achievement.fechaMarca});
      this.achievementForm.patchValue({time: time});
      this.achievementForm.patchValue({id: this.achievement.id});
      this.achievementForm.patchValue({distanciaTipoId: this.achievement.distanciaTipoId});
      this.achievementForm.patchValue({distance: this.achievement.distanciaMarca});
      this.activo = this.achievement.activo;
     } else {
      this.achievementForm.patchValue({id: null});  //requerido por backend
     }
  }

}